var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingUpchargeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5V14.1667H15V16.6667H16.6667V14.1667H19.1667V12.5H16.6667V10H15V12.5M12.475 9.675C12.375 8.56667 11.325 7.475 10 7.5C8.58333 7.525 7.5 8.58333 7.5 10C7.5 11.4167 8.58333 12.45 10 12.5C10.3167 12.5 10.6417 12.4333 10.95 12.3083C11.175 11.3917 11.55 10.525 12.475 9.675ZM10.8333 13.3333H5.83333C5.83333 12.4167 5.09167 11.6667 4.16667 11.6667V8.33333C5.09167 8.33333 5.83333 7.59167 5.83333 6.66667H14.1667C14.1667 7.59167 14.9167 8.33333 15.8333 8.33333V8.38333C16.3917 8.38333 16.95 8.48333 17.5 8.66667V5H2.5V15H11.1C10.9167 14.4417 10.8333 13.8833 10.8333 13.3333Z",
    fill: "#38761E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingUpchargeIcon);
export default __webpack_public_path__ + "static/media/pricingUpchargeIcon.719352d6ff46dcb292ae7c53a1d36d6b.svg";
export { ForwardRef as ReactComponent };